var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22375 16.2049C4.75063 16.2049 3.55643 17.3991 3.55643 18.8722V85.5552C3.55643 87.0283 4.75063 88.2225 6.22375 88.2225H57.7919C59.2651 88.2225 60.4593 87.0283 60.4593 85.5552V74.4414H64.0157V85.5552C64.0157 88.9925 61.2292 91.7789 57.7919 91.7789H6.22375C2.78647 91.7789 0 88.9925 0 85.5552V18.8722C0 15.4349 2.78647 12.6484 6.22375 12.6484H16.893V16.2049H6.22375ZM57.7919 16.2049H48.0118V12.6484H57.7919C61.2292 12.6484 64.0157 15.4349 64.0157 18.8722V44.6563H60.4593V18.8722C60.4593 17.3991 59.2651 16.2049 57.7919 16.2049Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1172 11.7604C15.1172 8.81418 17.5056 6.42578 20.4518 6.42578H44.4577C47.404 6.42578 49.7924 8.81418 49.7924 11.7604V17.0951C49.7924 20.0413 47.404 22.4297 44.4577 22.4297H20.4518C17.5056 22.4297 15.1172 20.0413 15.1172 17.0951V11.7604ZM20.4518 9.98221C19.4697 9.98221 18.6736 10.7783 18.6736 11.7604V17.0951C18.6736 18.0771 19.4697 18.8733 20.4518 18.8733H44.4577C45.4398 18.8733 46.2359 18.0771 46.2359 17.0951V11.7604C46.2359 10.7783 45.4398 9.98221 44.4577 9.98221H20.4518Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4504 3.7576C29.7497 3.7576 27.5603 5.94697 27.5603 8.64769H24.0039C24.0039 3.98281 27.7855 0.201172 32.4504 0.201172C37.1153 0.201172 40.8969 3.98281 40.8969 8.64769H37.3405C37.3405 5.94697 35.1511 3.7576 32.4504 3.7576Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 48.2146C8 46.2505 9.59227 44.6582 11.5564 44.6582H16.8911C18.8552 44.6582 20.4475 46.2505 20.4475 48.2146V59.773C20.4475 61.7372 18.8552 63.3294 16.8911 63.3294H11.5564C9.59227 63.3294 8 61.7372 8 59.773V48.2146ZM16.8911 48.2146H11.5564V59.773H16.8911V48.2146Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1133 32.2088C23.1133 30.2446 24.7055 28.6523 26.6697 28.6523H32.0043C33.9685 28.6523 35.5608 30.2446 35.5608 32.2088V59.7711C35.5608 61.7352 33.9685 63.3275 32.0043 63.3275H26.6697C24.7055 63.3275 23.1133 61.7352 23.1133 59.7711V32.2088ZM32.0043 32.2088H26.6697V59.7711H32.0043V32.2088Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2344 38.4334C38.2344 36.4692 39.8266 34.877 41.7908 34.877H47.1254C49.0896 34.877 50.6819 36.4692 50.6819 38.4334V50.8809H47.1254V38.4334L41.7908 38.4334V59.7719H46.2363V63.3284H41.7908C39.8266 63.3284 38.2344 61.7361 38.2344 59.7719V38.4334Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2041 76.1427L71.2031 72.1417L73.7179 69.627L77.7189 73.6279L75.2041 76.1427Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3666 73.7916C77.6235 71.5347 81.2827 71.5347 83.5396 73.7916L92.49 82.742C94.7469 84.9989 94.7469 88.6581 92.49 90.915C90.2331 93.1719 86.5739 93.1719 84.317 90.915L75.3666 81.9646C73.1097 79.7077 73.1097 76.0485 75.3666 73.7916ZM81.0249 76.3064C80.1568 75.4383 78.7494 75.4383 77.8814 76.3064C77.0133 77.1744 77.0133 78.5818 77.8814 79.4498L86.8318 88.4002C87.6998 89.2682 89.1072 89.2682 89.9752 88.4002C90.8433 87.5322 90.8433 86.1248 89.9752 85.2567L81.0249 76.3064Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7946 45.5467C54.1835 45.5467 48.0135 51.7167 48.0135 59.3278C48.0135 66.9389 54.1835 73.109 61.7946 73.109C69.4057 73.109 75.5758 66.9389 75.5758 59.3278C75.5758 51.7167 69.4057 45.5467 61.7946 45.5467ZM44.457 59.3278C44.457 49.7525 52.2193 41.9902 61.7946 41.9902C71.3699 41.9902 79.1322 49.7525 79.1322 59.3278C79.1322 68.9031 71.3699 76.6654 61.7946 76.6654C52.2193 76.6654 44.457 68.9031 44.457 59.3278Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.dec8069a1f899ce51e178c685b67f3e4.svg";
export { ForwardRef as ReactComponent };